import {
  useAvailabilitySlotTypes,
  TimeSlotTypeChip,
} from '@product-framework/index';

function DateCellContent({ cellDateValue, gridKey, cellDate, currentDate }) {
  const customScheduleAvailableSlots = cellDateValue?.slots
    ?.filter(sl => sl.source === 'SPECIAL_SCHEDULE' && sl.available === true)
    .map(s => s.code);

  const { getSlotByCode } = useAvailabilitySlotTypes();
  const working = Boolean(cellDateValue?.hasAvailability);
  const slots = Array.isArray(cellDateValue?.slots) ? cellDateValue.slots : [];

  const isPast = cellDate.isBefore(currentDate, 'day');

  return (
    working &&
    slots
      .filter(slotKey => slotKey.available === true)
      .map(slotKey => {
        const slotFound = getSlotByCode({ code: slotKey.code });

        return (
          <TimeSlotTypeChip
            key={`${gridKey}${slotKey?.code}`}
            name={slotFound?.name || slotKey.code}
            code={slotKey.code}
            type={
              customScheduleAvailableSlots.includes(slotKey?.code) ? '+SS' : ''
            }
            disabled={isPast}
          />
        );
      })
  );
}

export default DateCellContent;
